import React from "react";
import EmberlineLogo from "./EmberlineLogo";
import { Mail, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="relative bg-[#070708] border-t border-zinc-900 overflow-hidden"
      data-testid="footer-section"
    >
      {/* Marquee-like statement */}
      <div className="border-b border-zinc-900 py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <p className="font-heading uppercase tracking-tight text-5xl md:text-7xl lg:text-8xl leading-[0.9] steel-text max-w-5xl">
            Built Different.
            <br />
            <span className="ember-text">Built By Hand.</span>
          </p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <EmberlineLogo variant="footer" className="h-20 w-20 -ml-1" />
            <p className="mt-5 text-zinc-500 text-sm max-w-sm leading-relaxed">
              Custom smokers and firecraft handcrafted from reclaimed steel in
              a Cocoa, Florida workshop.
            </p>
          </div>

          <div className="flex items-center gap-6 text-zinc-300 font-body text-sm">
            <a
              href="mailto:emberlinefabrication@gmail.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 hover:text-[#FF7A00] transition-colors"
            >
              <Mail size={16} className="text-[#D9501E]" />
              emberlinefabrication@gmail.com
            </a>
            <a
              href="https://instagram.com/emberlinefabrication"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 hover:text-[#FF7A00] transition-colors"
            >
              <Instagram size={16} className="text-[#D9501E]" />
              @emberlinefabrication
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col md:flex-row gap-4 justify-between items-center text-zinc-600 font-body text-[10px] tracking-[0.4em] uppercase">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Emberline Fabrication · All Rights Forged</span>
          <span>Reclaimed Steel · Refined By Fire</span>
        </div>
      </div>
    </footer>
  );
}
